import { ValidationSchema } from 'validation-schema-library';

const vacancyGroupPositionSlotDataValidationSchema: ValidationSchema = {
  positionSlotOffices: {
    type: 'array',
    required: true,
    minSize: 1,
  },
  positionSlotWorkerType: {
    type: 'string',
    required: true,
  },
};

export default vacancyGroupPositionSlotDataValidationSchema;
